@if (taskCapacity) {
  <button #origin="cdkOverlayOrigin" cdkOverlayOrigin type="button" class="popup-trigger" (mouseenter)="show()" (mouseleave)="hide()">
    <i [nimbusIcon]="ICONS.INFO_CIRCLE_LIGHT"></i>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayPositions]="positions"
    [cdkConnectedOverlayOpen]="isOpen$ | async"
    (positionChange)="onPositionChange($event)"
  >
    <div class="task-capacity-popup" [class.above]="isAbove">
      <div class="total-capacity-section">
        <span class="section-label">{{ TranslationKeys.AdminUserTaskParallelizationTotalCapacity | translate }}</span>
        <div class="bar-track">
          <div class="bar-fill" [style.width.%]="cappedTotal" [class.full]="taskCapacity.total >= 100"></div>
        </div>
      </div>

      @if (visibleModalities.length) {
        <div class="modality-section">
          <span class="section-label">{{ TranslationKeys.AdminUserTaskParallelizationByModality | translate }}</span>
          @for (modality of visibleModalities; track modality.type) {
            <div class="modality-row">
              <span class="modality-label">{{ modality.labelKey | translate }}:</span>
              <div class="bar-track">
                <div class="bar-fill" [style.width.%]="modality.percentage" [class.full]="modality.percentage >= 100"></div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </ng-template>
}
